var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/generating",
    clipPath: "url(#clip0_0_20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.79199 5.29297C9.97135 5.31162 10.0979 5.47196 10.0801 5.63867C9.96461 6.7401 9.48498 7.80589 8.65039 8.64062C6.70537 10.5856 3.56123 10.5856 1.61621 8.64062L1.0752 8.10059C1.02946 8.05488 0.961118 8.04073 0.901367 8.06543C0.841716 8.09014 0.802912 8.14835 0.802734 8.21289V9.78125C0.802503 9.95853 0.653892 10.1064 0.476562 10.1064C0.303218 10.1064 0.160375 9.96248 0.160156 9.78125V7.05859C0.160156 6.86999 0.301134 6.73248 0.476562 6.73242H3.20801C3.38348 6.73242 3.52539 6.86995 3.52539 7.05859C3.52525 7.23594 3.38539 7.375 3.20801 7.375H1.64062C1.57606 7.37508 1.51794 7.41401 1.49316 7.47363C1.4684 7.53341 1.48161 7.60268 1.52734 7.64844L2.06836 8.18945C3.76246 9.88338 6.50413 9.88336 8.19824 8.18945C8.92157 7.46612 9.34013 6.53299 9.43555 5.58105C9.4539 5.40366 9.61352 5.27451 9.79199 5.29297ZM9.78125 0.160156C9.96964 0.160364 10.1064 0.301263 10.1064 0.476562V3.20801C10.1064 3.38336 9.96967 3.52518 9.78125 3.52539H7.05859C6.87713 3.52539 6.73242 3.38153 6.73242 3.20801C6.73259 3.0235 6.87925 2.88281 7.05859 2.88281H8.62598C8.69047 2.88276 8.74858 2.84366 8.77344 2.78418C8.79818 2.72446 8.7849 2.65513 8.73926 2.60938L8.19824 2.06836C6.50409 0.374241 3.7625 0.37422 2.06836 2.06836C1.33541 2.80131 0.926873 3.72501 0.822266 4.67578L0.821289 4.67676C0.802721 4.85625 0.64142 4.98272 0.474609 4.96484C0.317641 4.94851 0.201204 4.82343 0.186523 4.68066V4.61719C0.293024 3.51668 0.772714 2.45181 1.61621 1.61719V1.61621C3.55182 -0.319399 6.70515 -0.319835 8.65039 1.61621L9.19141 2.15723C9.2371 2.2028 9.30558 2.21696 9.36523 2.19238C9.42502 2.16762 9.46387 2.10866 9.46387 2.04395V0.476562C9.46392 0.299145 9.60382 0.160156 9.78125 0.160156Z",
    fill: "#2463EB",
    stroke: "#2463EB",
    strokeWidth: 0.32,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerating);
export default __webpack_public_path__ + "static/media/generating.5bb85d38634dc73140b2956986be29c8.svg";
export { ForwardRef as ReactComponent };